import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';

const TableRow = ({ row, ...restProps }, tableName) => {
    return <Table.Row {...restProps} className='table-row' />;
};

export default TableRow;
